var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dropzone",staticClass:"border-2 border-black border-dashed",class:{'border-hippiegreen': _vm.dragging}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }